export default __webpack_public_path__ + "577f279c23a7ee0f4917041279533564.svg";